export default __webpack_public_path__ + "static/media/correspondent12.b11ce91a.png";